 /* eslint-disable */

 global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;


import '../vendor/iframeResizer.min';
import "../vendor/owl-carousel/owl.carousel.min.css";
//import "../../vendor/owl-carousel/owl.theme.default.min.css";
import VideoController from "../js/global/video-controller";
import GetMobileOperatingSystem from "../js/global/mobile-operating-system";



let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;
let ellipsis = require('../vendor/jquery-ellipsis/fewlines-min');

var ran = false;
var mobileOS = GetMobileOperatingSystem();

var windowWidth = $(window).width();

var globalAssetPath = '';

function init(assetPath) {
    globalAssetPath = assetPath;
    initVideoLightbox();
    initOwlCarousel();
    initTruncateText();
    initIFrameResizer();
    updateBackgroundImages();
}

function initVideoLightbox() {
    const videoTrigger1 = document.querySelectorAll('.callout-play-button'); 
    const modalContain = document.querySelector('.video-modal');
    const modalClose = document.querySelector('.video-modal__close');
    //videoTrigger1.forEach((trigger) => {
    for (var i = 0, len = videoTrigger1.length; i < len; i++) {

    const videoTriggerVideoId = videoTrigger1[i].dataset.videoId;
    if(videoTriggerVideoId) {
        const video = new VideoController([videoTrigger1[i]], modalContain, modalClose, [videoTriggerVideoId]);
    }
    else {
        const video = new VideoController([videoTrigger1[i]], modalContain, modalClose, ['5652771834001']);
    }

  }
}

function initIFrameResizer() {
    //detect Internet Explorer
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

     const myIframe = document.querySelector('.contact-form iframe');
     if(isIE) {
        //do nothing
     }
     else {
        iFrameResize({
            log:false,
            checkOrigin:false,
            bodyPadding:'0 0 80px 0',
           }, myIframe);
     }
     

}

function initOwlCarousel() {
    mobileOS = GetMobileOperatingSystem();
    if (mobileOS !== 'unknown') {
        $('.testimonial-callout-container.owl-carousel').owlCarousel({
          loop:true,
          nav:true,
          dots: false,
          items: 1,
          navText: '',
          autoHeight: true
        });
    }else{
      $('.testimonial-callout-container.owl-carousel').owlCarousel('destroy');
   }

   setTimeout(function() {

    var owlnav = $('.owl-nav');

    if(owlnav) {

        owlnav.find('.owl-prev').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/sharecare-windows/arrow-left-large.png');
        owlnav.find('.owl-next').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/sharecare-windows/arrow-right-large.png');
    }

}, 100);

   
}

function initTruncateText() {

    mobileOS = GetMobileOperatingSystem();
    windowWidth = $(window).width();
    
    if(ran === true) {
        return;
    }

    
    if(mobileOS !== 'unknown') {

        const elems = $('.transformational-videos .featured-content, .awards-section .featured-content-bottom, .hospitality .featured-content')
        elems.fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 8
        });

        ran = true;
    }

}

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        var classes = (e.target.classList);
        if(classes.contains('bg-img')) {
            if(windowWidth > 1024) {
                bg = bg.replace('-mobile', '');
            }
        }
        e.target.style.backgroundImage = 'url(' + bg + ')';

    }
});

function updateBackgroundImages() {
    var elemBG, elemBGName, elemBGStyleName, splitString, endOfUrl, newEndOfUrl = '';
    windowWidth = $(window).width();
    elemBG = $('.hospitality .bg-img, .featured-header-video-bg');
    elemBG.each(function(index) {
        if($(this).attr('data-bg') !== undefined) {
            elemBGName, splitString, endOfUrl = '';
            elemBGName = $(this).attr('data-bg');
            splitString = elemBGName.split('/');
            endOfUrl = splitString[(splitString.length) - 1];

            if($(this).attr('style') !== undefined) {
                elemBGStyleName = $(this).attr('style');
                splitString = elemBGStyleName.split('/');
                endOfUrl = splitString[(splitString.length) - 1];
                endOfUrl = endOfUrl.replace('");', '');
            }

            if(windowWidth > 1024) {
                if(endOfUrl !== '') {
                    switch (endOfUrl) {
                        case 'hospitality-bg-mobile.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('-mobile', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('-mobile', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'mobile-header-bg.png':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('mobile-', '').replace('png', 'jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('mobile-', '').replace('png', 'jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                if(endOfUrl != '') {
                    switch (endOfUrl) {
                        case 'hospitality-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('hospitality-bg.jpg', 'hospitality-bg-mobile.jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('hospitality-bg.jpg', 'hospitality-bg-mobile.jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'header-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('header-bg.jpg', 'mobile-header-bg.png');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('header-bg.jpg', 'mobile-header-bg.png');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    });
}

$(window).resize(function() {
    initOwlCarousel();
    initTruncateText();
    updateBackgroundImages();
  });

export default init;